function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.265,1.438c-5.972,0-10.812,4.841-10.812,10.812s4.841,10.812,10.812,10.812s10.812-4.841,10.812-10.812 S18.237,1.438,12.265,1.438z M9.626,13.055l5.75,5.805c0.215,0.201,0.303,0.504,0.229,0.789c-0.074,0.283-0.299,0.506-0.584,0.578 c-0.285,0.07-0.58-0.021-0.781-0.238l-7.105-7.174c-0.312-0.315-0.312-0.819,0-1.133l7.107-7.175 c0.199-0.215,0.496-0.304,0.779-0.233c0.287,0.072,0.512,0.293,0.584,0.578c0.074,0.285-0.014,0.587-0.227,0.788l-5.75,5.805 c0,0-0.545,0.514-0.545,0.846C9.083,12.624,9.626,13.055,9.626,13.055z"
});

var SvgBackArrow = function SvgBackArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "24.531px",
    height: "24.5px",
    viewBox: "0 0 24.531 24.5",
    enableBackground: "new 0 0 24.531 24.5",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBackArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-arrow.03fc9a42.svg";
export { ForwardRef as ReactComponent };